// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14R3p","buttons":"Footer_buttons__-Y7Ch"};